exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-container[data-v-04d34c7e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-bottom:12px;cursor:-webkit-grab;cursor:grab}.preview[data-v-04d34c7e]{width:204px;border:1px solid #e3e3e3;margin-right:12px}", ""]);

// exports
